module.exports = __webpack_public_path__ + "static/media/raindrops.1759037c.svg";